




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service"
import {VrstaOdrzavanja} from "@/services/BackendProxies";

@Component({})
export default class PreventivnoOdrzavanjeEditor extends Vue {
    odrzavanja = [];
    preventivnaOdrzavanja = [];
    @Prop() value!: string;

    model = '';

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {}

    async created() {
        this.odrzavanja = await dataProxy.vratiVrsteOdrzavanja();
        const preventivnaOdrz = this.odrzavanja.filter(x => x.preventivno === true);
        preventivnaOdrz.unshift(VrstaOdrzavanja.fromJS({id: '', oznaka: '...'}));
        this.preventivnaOdrzavanja = preventivnaOdrz.map(p => ({id: p.id, text: `${p.oznaka} ${p.naziv || ''}`}));
        this.model = this.value;
    }

}
